import { render, staticRenderFns } from "./BindErpBox.vue?vue&type=template&id=92895268&scoped=true"
import script from "./BindErpBox.vue?vue&type=script&lang=js"
export * from "./BindErpBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92895268",
  null
  
)

export default component.exports